import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';

import { AuthService } from './auth.service';

import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireStorageModule } from 'angularfire2/storage';
import 'firebase/storage';

import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { ProfileComponent, DialogDelete, DialogArquivar, DialogAddPasta, DialogAddPastaBoleto, DialogArquivarBoleto } from './profile/profile.component';
import { EmailComponent } from './email/email.component';

import { AppRoutingModule } from './app-routing.module';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { UserProvider } from './user.service';
import { DocumentosComponent } from './documentos/documentos.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatProgressBarModule, MatButtonModule ,MatDialogModule, MatMenuModule, MatTabsModule } from '@angular/material';

export const firebaseConfig = {
  apiKey: "AIzaSyBos45wOC6TfNWy0sB4BRjMlStVm5z_YLo",
  authDomain: "documentoagora-1fcf1.firebaseapp.com",
  databaseURL: "https://documentoagora-1fcf1.firebaseio.com",
  projectId: "documentoagora-1fcf1",
  storageBucket: "documentoagora-1fcf1.appspot.com",
  messagingSenderId: "17328837428"
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    ProfileComponent,
    EmailComponent,
    DocumentosComponent,
    DialogDelete,
    DialogArquivar,
    DialogArquivarBoleto,
    DialogAddPasta,
    DialogAddPastaBoleto
  ],
  entryComponents:[
    DialogDelete,
    DialogArquivar,
    DialogArquivarBoleto,
    DialogAddPasta,
    DialogAddPastaBoleto
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFirestoreModule.enablePersistence(),
    AngularFireStorageModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    BrowserAnimationsModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressBarModule,
    MatMenuModule,
    MatTabsModule

  ],
  providers: [
    AuthService,
    UserProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts